module.exports = __webpack_public_path__ + "441f2c72ff3c6029893a89922e94c12b.png";